'use client';
function isIterableSet(n) {
    return n instanceof Set;
}
function isNonNullish(n) {
    return null != n;
}
function isFunction(n) {
    return 'function' == typeof n;
}

export { isFunction, isIterableSet, isNonNullish };
